
// / In accordance with ISO 8601 a week starts with Monday, which has the value 1.
// / For more information see: https://en.wikipedia.org/wiki/ISO_8601
export enum DayOfWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7
}
